import React, { useMemo } from 'react';
import { format, isPast, isToday } from 'date-fns';

import useScreen from '@lyearn/core/hooks/useScreen';
import { DateFormats } from '@lyearn/core/utils/time/types';
import { useTranslation } from '@lyearn/i18n';
import { Calendar2Outline } from '@lyearn/icons';
import { DateVariant, Input, Stack, Typography } from '@lyearn/ui';
import DatePicker from '@/components/DatePicker';

import { HabitFrequencyProps } from '../../types';

const HabitStartsOnDate = (props: Pick<HabitFrequencyProps, 'value' | 'onChange'>) => {
  const { value, onChange } = props;
  const { t } = useTranslation();
  const { isMobile } = useScreen();

  const resolvedDate = useMemo(
    () => (value.startDate ? new Date(value.startDate) : undefined),
    [value.startDate],
  );

  return (
    <Stack direction="col" gapY={8}>
      <Typography className="ps-8" variant="body-short-02">
        {t('StartOn')}
      </Typography>
      <DatePicker
        pickerProps={{
          disablePast: true,
          variant: DateVariant.Date,
          selectedTime: resolvedDate,
          onChange: (selectedTime) => {
            if (!selectedTime || (isPast(selectedTime) && !isToday(selectedTime))) return null;
            onChange({ ...value, startDate: selectedTime.toISOString() });
          },
          dateFormat: DateFormats.FullDate,
        }}
        showActionButtons={false}
        showSelectedTime={!isMobile}>
        <Input
          className="w-full"
          endAdornment={
            <Calendar2Outline
              className="h-24 w-24 flex-shrink-0"
              fillColorToken="icon-placeholder"
            />
          }
          placeholder={t('Habits:Editor.ChooseDate')}
          size="large"
          value={resolvedDate ? format(resolvedDate, 'dd MMM yyyy') : undefined}
        />
      </DatePicker>
    </Stack>
  );
};

export default HabitStartsOnDate;
